(() => {
  const findField = (root, key) =>
    root.querySelector(`input[data-wpd-input="${key}"]:not([data-pp-proxy])`) ||
    [...root.querySelectorAll('input')].find(el =>
      new RegExp(key, 'i').test([
        el.placeholder,
        el.name,
        el.getAttribute('aria-label'),
        el.dataset.wpdInput
      ].filter(Boolean).join(' ')) &&
      el.type !== 'hidden' && !el.dataset.ppProxy
    );

  const enhanceCalculator = root => {
    const width = findField(root, 'width');
    const height = findField(root, 'height');
    if (!width || !height) return;

    const calc = width.closest('wallpaper-dimensions') || width.closest('.shopify-app-block') || width.parentElement;
    if (!calc || calc.querySelector('.pp-unit-switch')) return;

    calc.classList.add('pp-calculator-card');
    const switcher = document.createElement('div');
    switcher.className = 'pp-unit-switch';
    switcher.innerHTML = '<div><strong>Enter your wall size</strong><span>We recommend adding 5 cm / 2 in for trimming.</span></div><div role="group" aria-label="Measurement unit"><button type="button" class="is-active" data-unit="cm">cm</button><button type="button" data-unit="in">inches</button></div>';
    calc.prepend(switcher);

    const makeProxy = (source, key) => {
      const proxy = source.cloneNode(true);
      proxy.removeAttribute('name');
      proxy.removeAttribute('id');
      proxy.dataset.ppProxy = key;
      proxy.style.display = 'none';
      source.insertAdjacentElement('afterend', proxy);
      return proxy;
    };

    const wIn = makeProxy(width, 'width');
    const hIn = makeProxy(height, 'height');
    const dispatchCm = (proxy, source) => {
      const inches = parseFloat(proxy.value);
      if (!Number.isFinite(inches)) return;
      source.value = (inches * 2.54).toFixed(1);
      source.dispatchEvent(new Event('input', { bubbles: true }));
      source.dispatchEvent(new Event('change', { bubbles: true }));
    };

    wIn.addEventListener('input', () => dispatchCm(wIn, width));
    hIn.addEventListener('input', () => dispatchCm(hIn, height));

    switcher.querySelectorAll('button').forEach(btn => btn.addEventListener('click', () => {
      const inches = btn.dataset.unit === 'in';
      switcher.querySelectorAll('button').forEach(b => b.classList.toggle('is-active', b === btn));
      [width, height].forEach(el => el.style.display = inches ? 'none' : '');
      [wIn, hIn].forEach(el => el.style.display = inches ? '' : 'none');
      if (inches) {
        wIn.value = width.value ? (parseFloat(width.value) / 2.54).toFixed(1) : '';
        hIn.value = height.value ? (parseFloat(height.value) / 2.54).toFixed(1) : '';
      }
      calc.querySelectorAll('*').forEach(el => {
        if (!el.closest('.pp-unit-switch') && el.tagName !== 'BUTTON' && el.children.length === 0 && /^cm$/i.test(el.textContent.trim())) {
          el.style.display = inches ? 'none' : '';
        }
      });
    }));

    const storefrontCurrency = document.querySelector('meta[property="og:price:currency"]')?.content;
    if (storefrontCurrency === 'USD') switcher.querySelector('button[data-unit="in"]')?.click();

    const details = calc.closest('product-form, .product-information, [class*="product-details"], dialog, quick-add-modal') || calc.parentElement;
    if (details && !details.querySelector('.pp-cro-reassurance')) {
      const info = document.createElement('div');
      info.className = 'pp-cro-reassurance';
      info.innerHTML = '<b>Made specifically for your wall</b><span>✓ Custom dimensions &nbsp; ✓ Secure checkout &nbsp; ✓ Clear installation guide</span><a href="/pages/how-to-measure-wall-for-wallpaper">Need help measuring? View the guide →</a>';
      calc.insertAdjacentElement('afterend', info);
    }
  };

  const enhanceAll = root => {
    if (root instanceof Element && root.matches('wallpaper-dimensions, .shopify-app-block, dialog, quick-add-modal')) enhanceCalculator(root);
    if (root.querySelectorAll) {
      enhanceCalculator(root);
      root.querySelectorAll('wallpaper-dimensions, .shopify-app-block, dialog, quick-add-modal').forEach(enhanceCalculator);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    enhanceAll(document);

    if (document.body.classList.contains('product') && document.body.className.match(/template-suffix-wallpaper(?:-cro)?(?:\s|$)/)) {
      const description = document.querySelector('.text-block[class*="product_description"]');
      if (description && !description.nextElementSibling?.classList.contains('pp-description-toggle')) {
        description.classList.add('pp-description-collapsed');
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'pp-description-toggle';
        toggle.textContent = 'Read full description';
        toggle.addEventListener('click', () => {
          const open = description.classList.toggle('is-open');
          toggle.textContent = open ? 'Show less' : 'Read full description';
        });
        description.insertAdjacentElement('afterend', toggle);
      }
    }

    new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) enhanceAll(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  });
})();